export const [
    FETCH_PRINT_INVOICE,
    FETCH_INVOICE_SITE_MAPS,
] = [
    'FETCH_PRINT_INVOICE',
    'FETCH_INVOICE_SITE_MAPS',
];
